import React from "react";
import { Box, Typography, IconButton, Select, MenuItem } from "@material-ui/core";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

interface CustomPaginationProps {
  page: number;
  rowsPerPage: number;
  totalCount: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (rowsPerPage: number) => void;
}

const CustomPagination: React.FC<CustomPaginationProps> = ({
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const totalPages = Math.ceil(totalCount / rowsPerPage);
  const start = totalCount === 0 ? 0 : page * rowsPerPage + 1;
  const end = Math.min((page + 1) * rowsPerPage, totalCount);

  const handleChangeRowsPerPage = (event: React.ChangeEvent<{ value: unknown }>) => {
    onRowsPerPageChange(Number(event.target.value));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flex: "1 1 auto",
        justifyContent: "flex-end",
        alignItems: "center",
        boxSizing: "border-box",
        px: "8px",
        width: "100%",
        color: "rgba(0, 0, 0, 0.54)",
        fontSize: "13px",
        minHeight: "56px",
        borderTop: "1px solid rgba(0, 0, 0, 0.12)",
      }}
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      mt={2}
      className="rdt_Pagination"
    >
      <Typography variant="body2">Usuários por página</Typography>

      <Select
        value={rowsPerPage}
        onChange={handleChangeRowsPerPage}
        style={{ marginLeft: 8, marginRight: 8, minWidth: 30 ,  color: "rgba(0, 0, 0, 0.54)",}}
      >
        {[5, 10, 20, 50].map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>

      <Typography variant="body2">
        {start}-{end} de {totalCount}
      </Typography>

      <IconButton onClick={() => onPageChange(0)} disabled={page === 0}>
        <FirstPageIcon fontSize="small" />
      </IconButton>

      <IconButton onClick={() => onPageChange(page - 1)} disabled={page === 0}>
        <NavigateBeforeIcon fontSize="small" />
      </IconButton>

      <IconButton onClick={() => onPageChange(page + 1)} disabled={page >= totalPages - 1}>
        <NavigateNextIcon fontSize="small" />
      </IconButton>

      <IconButton onClick={() => onPageChange(totalPages - 1)} disabled={page >= totalPages - 1}>
        <LastPageIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default CustomPagination;
